module.exports = __webpack_public_path__ + "share-02.svg?77aea2c30d588f72ed54420f01f9b71b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/share-02.svg
// module id = 7
// module chunks = 0